export const REMOVE_ITEMS_TYPE = {
  WASTE: 'waste',
  SHIPMENT: 'shipment'
}
